import React from 'react';
import ChatMessage from './ChatMessage';
import ChatQuickPrompts from './ChatQuickPrompts';
import ChatTypingIndicator from './ChatTypingIndicator';
import ChatWelcome from './ChatWelcome';

export default function ChatMessageList({
  messages,
  showWelcome,
  isLoading,
  onQuickPrompt,
  messagesContainerRef,
  messagesEndRef,
  onScroll
}) {
  return (
    <div className="chatbox-messages" ref={messagesContainerRef} onScroll={onScroll}>
      {showWelcome ? (
        <ChatWelcome />
      ) : (
        messages.map((message, index) => (
          <ChatMessage key={index} message={message} messages={messages} index={index} />
        ))
      )}

      {showWelcome && <ChatQuickPrompts onSelect={onQuickPrompt} />}
      {isLoading && <ChatTypingIndicator />}
      <div ref={messagesEndRef} />
    </div>
  );
}
